// extracted by mini-css-extract-plugin
export default {"root":"TermsOfService_root__YB9-b"};